import React from 'react';
import { Sparkles, SprayCan, Pill, Apple, Stethoscope, Smartphone, Droplets, Flower2, AlertTriangle } from 'lucide-react';

const ITEMS = [
  { icon: Sparkles, t: 'Cosméticos y maquillaje', d: 'Labiales, bases, sombras y similares' },
  { icon: Flower2, t: 'Perfumes y fragancias', d: '' },
  { icon: Droplets, t: 'Desodorantes y cremas corporales', d: '' },
  { icon: SprayCan, t: 'Aerosoles y productos en spray', d: '' },
  { icon: Pill, t: 'Medicamentos y suplementos', d: 'Para uso personal, con receta cuando corresponda' },
  { icon: Apple, t: 'Alimentos para consumo humano', d: '' },
  { icon: Stethoscope, t: 'Equipos médicos e insumos de salud', d: '' },
  { icon: Smartphone, t: 'Teléfonos y computadoras usados', d: 'Deben llegar en perfecto estado' },
];

const PermisosSection = () => (
  <section id="permisos" className="py-20 px-6 bg-white" data-testid="permisos-section">
    <div className="max-w-6xl mx-auto">
      <p className="uppercase tracking-[0.25em] text-xs font-bold mb-3" style={{ color: 'var(--sendhapy-teal)' }}>Antes de comprar</p>
      <h2 className="text-3xl sm:text-4xl font-extrabold mb-4" style={{ color: 'var(--sendhapy-night)' }}>Productos que pueden requerir permiso especial</h2>
      <p className="text-base md:text-lg text-gray-600 mb-10 max-w-2xl">
        Estos productos pueden necesitar permiso, documentación o revisión adicional. Cuando aplica, se suma un recargo de $2 por paquete.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {ITEMS.map((i) => (
          <div key={i.t} className="rounded-2xl p-5 border border-black/5" style={{ background: 'var(--sendhapy-smoke)' }}>
            <i.icon size={24} style={{ color: 'var(--sendhapy-teal)' }} className="mb-3" />
            <p className="font-bold text-sm" style={{ color: 'var(--sendhapy-night)' }}>{i.t}</p>
            {i.d && <p className="text-xs text-gray-500 mt-1">{i.d}</p>}
          </div>
        ))}
      </div>
      <div className="flex gap-3 items-start rounded-2xl p-5 border-l-4" style={{ background: '#FFF9CC', borderColor: 'var(--sendhapy-yellow)' }} data-testid="permisos-advertencia">
        <AlertTriangle size={20} className="shrink-0 mt-0.5" style={{ color: 'var(--sendhapy-teal)' }} />
        <p className="text-sm text-gray-700">
          Aparecer en esta lista no garantiza que el producto pueda importarse. La admisibilidad depende del producto, los permisos,
          la documentación y las disposiciones aplicables. Si tienes dudas, consúltanos antes de comprar.
        </p>
      </div>
    </div>
  </section>
);

export default PermisosSection;
